export default "__VITE_ASSET__D7x908ae__"